export default __webpack_public_path__ + "static/media/testimonials@2x.4610ca4a.png";